import { Component, inject, OnInit } from '@angular/core';
import { DatePipe, NgTemplateOutlet } from '@angular/common';

import { BookingStore } from '../../../../pages/booking/store';

import { FlightTimePipe } from '../../../pipes';

@Component({
  selector: 'app-itinerary',
  templateUrl: './itinerary.component.html',
  standalone: true,
  imports: [NgTemplateOutlet, DatePipe, FlightTimePipe],
})
export class ItineraryComponent implements OnInit {
  private _bookingStore = inject(BookingStore);
  readonly selectFlightState = this._bookingStore.selectFlight;

  ngOnInit(): void {}
}
